export default "__VITE_ASSET__c4e4a809__"